export default __webpack_public_path__ + "img/emoji.776ad341.svg";